import { render, staticRenderFns } from "./dialog-view-new.vue?vue&type=template&id=eec574e0&scoped=true"
import script from "./dialog-view-new.vue?vue&type=script&lang=js"
export * from "./dialog-view-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec574e0",
  null
  
)

export default component.exports